export default __webpack_public_path__ + "static/media/icon_underline.2f98186f.svg";